import command from './command'

class TiyanVcard {

    //初始化调用接口
    Command = new command()

    //V卡体验接口
    getVcard(param) {
        return this.Command.execute({ api: '/api/mbc/TakeMemberCardForNewLogin', param: param });
    }
}

export default TiyanVcard


// WEBPACK FOOTER //
// ./src/services/Vcard-titan.js